import { useCallback, useMemo } from 'react';

import { Countries } from '~globals/types/enums';
import { useAppSelector } from '~hooks/index';
import { selectAuth } from '~store/slices/auth/index';
import { BASE_URL as API_BASE_URL } from '~config/api';
import { ADMIN_VEHCILE_ENPOINTS } from '~services/admin/vehicle';
import { ADMIN_DRIVER_ENPOINTS } from '~services/admin/driver';

type SampleTemplatesEntity =
  | 'items'
  | 'customer'
  | 'vehicles'
  | 'drivers'
  | 'partnerCompanies';

type SampleTemplatesUrls = Record<SampleTemplatesEntity, string>;

const sampleTemplateBaseUrl = 'https://routixstg.blob.core.windows.net/assets';

export const useSampleTemplates = (): SampleTemplatesUrls => {
  const { user } = useAppSelector(selectAuth);

  const currentCountry = useMemo(
    () => user?.company.countryId ?? Countries.Argentina,
    [user?.company.countryId],
  );

  const getSampleTemplateUrl = useCallback(
    (entitySample: string, withCountry: boolean): string => {
      const nameSpace = withCountry
        ? `${entitySample}_${currentCountry}`
        : entitySample;

      return `${sampleTemplateBaseUrl}/${nameSpace}.xlsx`;
    },
    [currentCountry],
  );

  const getTemplateByApi = useCallback(
    (path: string) => `${API_BASE_URL}${path}`,
    [],
  );

  const sampleTemplatesUrls = useMemo<SampleTemplatesUrls>(
    () => ({
      items: getSampleTemplateUrl('ItemsSample', true),
      customer: getSampleTemplateUrl('CustomerSample', true),
      vehicles: getTemplateByApi(ADMIN_VEHCILE_ENPOINTS.getTemplateCSV),
      drivers: getTemplateByApi(ADMIN_DRIVER_ENPOINTS.getTemplateCSV),
      partnerCompanies: getSampleTemplateUrl('GiversSample', false),
    }),
    [getSampleTemplateUrl, getTemplateByApi],
  );

  return sampleTemplatesUrls;
};
